import { AxiosError, AxiosResponse } from "axios"
import { useMutation } from "react-query"

import axiosInstance from "../../api"
import { MutationOptions } from "../../api.types"
import { Endpoint } from "../../enpoints.types"

interface IIntercomArgs {
  options?: MutationOptions<IResponseIntercom, null>
}

interface IResponseIntercom {
  id: number
  first_name: string
  last_name: string
  email: string
  date_of_birth: string
  avatar_url: string
  subscription_status: "active" | "past_due" | "unpaid" | "cancelled"
  is_school_admin: boolean
  intercom_opened: boolean
}

export const useMutationIntercom = (args?: IIntercomArgs) =>
  useMutation<AxiosResponse<IResponseIntercom>, AxiosError, null>(async () => {
    return await axiosInstance.post(Endpoint.TEACHER_ME_INTERCOM_OPEN)
  }, args?.options)
